@if ((useLazyLoad && !isLoaded) || slices?.length > 0) {
  <aside>
    <div class="wc-spy-target" [sdSpyTarget]="componentUid"></div>
    <wc-wrapper [contentWrapper]="wrapper" [componentWidth]="componentWidth">
      <sd-accordion-group-image sd-component-wrapper-component
                                [slices]="slices"
                                [theme]="themeAccordion"
                                [isSmall]="isSmall"
                                [brand]="brandCorner"
                                [isLoading]="useLazyLoad && !isLoaded"
                                (sliceClosed)="closeSlice($event)"
                                (sliceOpened)="openSlice($event)"
                                (urlClicked)="openUrl($event)"
      />
    </wc-wrapper>
  </aside>
}
